import { Helper } from "../core/util/helper";
import { ResourceAppProps } from "./resource";
import RessPalaInGrid from "./ressPalaInGrid";
import RessPassInGrid, { RessPass } from "./ressPassInGrid";
import React from "react";
export default class RessPassApp extends React.Component<ResourceAppProps, {
    focusedItem: RessPass;
}>{
    public ressPassInGridRef: RessPassInGrid;
    public ressPalaInGridRef: RessPalaInGrid;

    constructor(props) {
        super(props);
        this.state = {
            focusedItem: null
        };
        this.props.dataSources["passDataSource"] = [];
    }

    private onRessPassRowClicked = (dataItem: RessPass) => {
        this.setState({ focusedItem: dataItem });
    }

    private removeFilter = () => {
        this.setState({ focusedItem: null });
    }

    private onRessPassDeleted = (dataItems: RessPass[]) => {
        this.ressPalaInGridRef.deleteByRessPass(dataItems);
    }

    private renderRessPassInGrid = () => {
        return <RessPassInGrid {...this.props} ref={(ref) => this.ressPassInGridRef = ref} onRowClicked={this.onRessPassRowClicked}
            onRessPassDeleted={this.onRessPassDeleted} />
    }

    private renderRessPalaInGrid = (dataItem: RessPass) => {
        if (Helper.hasValue(this.ressPassInGridRef)) {
            let ressPassEntries: RessPass[] = this.ressPassInGridRef.getEntries() ?? [];
            this.props.dataSources["passDataSource"] = ressPassEntries.map(x => { return { PassNr: x.Passnr, Pass: x.Pass } });
        }
        return <RessPalaInGrid {...this.props} ressPass={dataItem} ref={(ref) => this.ressPalaInGridRef = ref} loadAll={this.removeFilter} />;
    }

    render() {
        return (<>
            {this.renderRessPassInGrid()}
            {this.renderRessPalaInGrid(JSON.parse(JSON.stringify(this.state.focusedItem)))}
        </>);
    }
}